import React from 'react';
import {Card, Typography, Row, Col, Flex} from 'antd';

import {big_login_logo, big_reverse_logo} from '../Config/Images';
import { ListItemsInfoLinks } from '../Components/ListItemsInfoLinks';
import { DiazarAlerts } from '../Components/DiazarAlerts';
import {SocialMedia} from '../Components/Layouts/SocialMedia';

const { Text, Title } = Typography;

interface ViewProps {
    children?: React.ReactNode;
    textContent?: string;
    loginTitle: string;
    loginSubtitle?: string;
}

export const LoginLayout: React.FunctionComponent<ViewProps> = (props) => {

    const style = {
        background: `transparent url(${big_login_logo}) no-repeat center center`,
        backgroundSize: 'auto 70%'
    };

    return (
        <React.Fragment>
            <DiazarAlerts isToast/>
            <Row style={ {minHeight: '100vh'} } align="middle" gutter={20} id="login-layout">
                <Col xs={24} sm={24} md={12} id={'login-form'} style={ {minHeight:'100%'} }>
                    <Row justify="center" align="middle" style={ {minHeight:'100%'} }>
                        <Col xs={24} sm={22} md={24} lg={20} xl={16} xxl={14}  >
                            <Card style={{border: 'none'}}>
                                <img src={big_reverse_logo} alt="Diazar Logo" height={30}/>
                                <Title level={4}>{props.loginTitle}</Title>
                                {props.loginSubtitle && <Text className="poppins-light">{props.loginSubtitle}</Text>}
                                <div style={{marginTop: 16}}>{props.textContent}</div>
                                <div style={{marginTop: 24}}>

                                </div>
                                <div style={{marginTop: 16}}>{props.children}</div>

                                <SocialMedia />
                            </Card>
                        </Col>
                    </Row>

                </Col>
                <Col xs={0} sm={0} md={12} id={'login-info'}>
                    <Flex vertical align="center" justify="space-between" style={{ height:'100%' }}>
                        <Row className="img-login-bg" style={style}>
                            &nbsp;
                        </Row>
                        <Row align="middle" className="login-info-text" gutter={20}>
                            <Col>
                                <Text className="text-white">Todos los derechos reservados Diazar.com 2024©</Text>
                            </Col>
                            <Col>
                                <Text className="text-white">
                                    <ListItemsInfoLinks color="orange"/>
                                </Text>
                            </Col>
                        </Row>
                    </Flex>
                </Col>
            </Row>
        </React.Fragment>
    );
};
